import { SrPartialPackingTypeMap } from '@plato/data/starrocks/types';

const checkQuantityForRounding = (
    quantity: number | null,
    salesUnitsPerPackageUnit: number,
    partialPackingType: SrPartialPackingTypeMap,
) => {
    if (quantity === null) return quantity;

    if (partialPackingType === SrPartialPackingTypeMap.NO_RESTRICTION) {
        return quantity;
    }

    let newQuantitiy = quantity;

    if (partialPackingType === SrPartialPackingTypeMap.ALWAYS_ROUND_DOWN) {
        newQuantitiy = Math.floor(quantity / salesUnitsPerPackageUnit) * salesUnitsPerPackageUnit;
    } else if (partialPackingType === SrPartialPackingTypeMap.ALWAYS_ROUND_UP) {
        newQuantitiy = Math.ceil(quantity / salesUnitsPerPackageUnit) * salesUnitsPerPackageUnit;
    } else {
        newQuantitiy = Math.round(quantity / salesUnitsPerPackageUnit) * salesUnitsPerPackageUnit;
    }

    if (newQuantitiy === 0) {
        newQuantitiy = salesUnitsPerPackageUnit;
    }

    return newQuantitiy;
};

const showPackgingUnitModalFn = (partialPackingType: SrPartialPackingTypeMap) => {
    return [
        SrPartialPackingTypeMap.NO_PACKAGE_BREAK as string,
        SrPartialPackingTypeMap.ONLY_ROUND_DOWN,
        SrPartialPackingTypeMap.ONLY_ROUND_DOWN,
    ].includes(partialPackingType);
};

export { checkQuantityForRounding, showPackgingUnitModalFn };
